import { render, staticRenderFns } from "./EmployeeBankInfo.vue?vue&type=template&id=6073e1ff&scoped=true"
import script from "./EmployeeBankInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeBankInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBankInfo.vue?vue&type=style&index=0&id=6073e1ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073e1ff",
  null
  
)

export default component.exports